import { render } from "./PageError.vue?vue&type=template&id=b4b174ba&scoped=true"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"

import "./PageError.vue?vue&type=style&index=0&id=b4b174ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b174ba"]])

export default __exports__